export default {
  R: 'red',
  A: 'yellow',
  G: 'green',
  B: 'blue',
};
